/*
 * The icon and name a phone puts on its home screen (owner, Oct 31: "set one for it so it looks good, icon and name").
 * Picked by the web address: the brand's symbol on its color (public/icons, cut from the brand logos), the name under the
 * icon, and a manifest so Android and iPhone open it full screen like an app.
 */
const BRANDS = {
  cleaners: { name: "The Cleaners", color: "#00929F" },
  groundsmen: { name: "GroundsMen", color: "#367C2B" },
  washers: { name: "The Washers", color: "#0E5A8A" },
  marketers: { name: "Marketers", color: "#1D1D1F" },
  steward: { name: "Steward", color: "#1D1D1F" },
} as const;

function brandHere(host: string): keyof typeof BRANDS {
  if (host.endsWith("thecleanersusa.com")) return "cleaners";
  if (host.endsWith("thegroundsmen.com")) return "groundsmen";
  if (host.endsWith("exteriorwashers.com")) return "washers";
  if (host.endsWith("themarketers.agency")) return "marketers";
  return "steward";
}

function tag(kind: "link" | "meta", key: string, value: string, attrs: Record<string, string>) {
  const sel = kind === "link" ? `link[rel="${value}"]` : `meta[name="${value}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement(kind);
    el.setAttribute(key, value);
    document.head.appendChild(el);
  }
  for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
}

export function setHomeIcon() {
  const id = brandHere(window.location.hostname);
  const b = BRANDS[id];
  tag("link", "rel", "apple-touch-icon", { href: `/icons/${id}-180.png` });
  tag("link", "rel", "manifest", { href: `/manifest-${id}.json` });
  tag("meta", "name", "apple-mobile-web-app-title", { content: b.name });
  tag("meta", "name", "apple-mobile-web-app-capable", { content: "yes" });
  tag("meta", "name", "mobile-web-app-capable", { content: "yes" });
  tag("meta", "name", "application-name", { content: b.name });
}
